module.exports = __webpack_public_path__ + "static/media/share-black.0239fac2.png";